//Require scripts
// require('./script')

// import '../sass/settings.scss';
// import $ from "jQuery";
window.jQuery = window.$ = jQuery;

import "../sass/app.sass";
import "./fouc.js";
import "../../node_modules/slick-carousel/slick/slick.js";
import "../../node_modules/slick-carousel/slick/slick.css";
// import "../../node_modules/isotope-layout/dist/isotope.pkgd.js";
// import "./lib/audioplayer.min.js";
import "./isotope.js";
import "./slick.js";
// import "./audio.js";
import "./sticky.js";
import "./glossar.js";
import "./filterGlossar.js";
import "./overwriteLinks";
import "./grid-row-height.js";
import "./filterPublikationen.js";
import "./externalLinks.js";

import whatInput from "what-input";

import Foundation from "foundation-sites";
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
// import './lib/foundation-explicit-pieces';

window.$ = window.jQuery = require("jquery");
$(document).foundation();
// $(document).foundation('interchange', 'reflow');
